import { useEffect, useState } from "react";
import { teamApi } from "api/team";
import { getCurrentUser } from "api/client";

/**
 * Real team members for rep dropdowns (Sprint 15 QA audit #9) — replaces the
 * hardcoded phantom reps. Falls back to the current user when the members
 * endpoint is unavailable (Rep/ReadOnly roles get 403 on it).
 * Re-audit fix: one option per person — fullName preferred, email only when
 * no name exists (no more duplicate "UX Tester" + "ux.tester@local.test").
 */
export default function useReps() {
  const [reps, setReps] = useState([]);

  useEffect(() => {
    const me = getCurrentUser();
    const meName = me?.fullName || me?.email || "";
    const fallback = meName ? [meName] : [];
    teamApi
      .listMembers()
      .then((members) => {
        const names = new Set(fallback);
        (members || []).forEach((m) => {
          names.add(m?.fullName || m?.name || m?.email || "");
        });
        setReps([...names].filter(Boolean));
      })
      .catch(() => setReps(fallback));
  }, []);

  return reps;
}